export default __webpack_public_path__ + "static/media/ico-aws-internet-gateway-circle-solid.51bc9306.svg";